import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from './api.service';

@Injectable({
  providedIn: 'root'
})

export class TowGService {

  constructor(private apiService: ApiService) {}

  /**
   * 2G lines list
   */
  getList(): Observable<Array<string>> {
    return this.apiService.get('gsm/two-g/lines');
  }
}
